// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2TTeT","vLegacy":"SelectSecondary_vLegacy__3VDH6","error":"SelectSecondary_error__UUjhJ","disabled":"SelectSecondary_disabled__1IAd8"};